<template>
  <div class="bg-filter">
    <br />
    <br />
    <div class="container" style="padding: 1rem;">
      <h3 class="is-size-4 has-text-white">
        {{ $t("whyTitle") }}
      </h3>
      <p class="has-text-white">{{ $t("why") }}</p>
      <br />
      <div class="columns is-gapless">
        <div class="column" v-for="(item, i) in $t('timeLine')" :key="i">
          <div class="time-line is-hidden-touch">
            <i
              :class="
                `time-line-icon fa-solid fa-circle-right fa-2x has-text-white ${
                  i == 0 ? 'is-marginless' : ''
                }`
              "
            ></i>
            <i
              class="
                fa-solid fa-caret-right fa-2x
                has-text-white
                is-pulled-right
              "
            ></i>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column" v-for="(item, i) in $t('timeLine')" :key="i">
          <h4 class="is-size-4 has-text-white">{{ item.time }}</h4>

          <h4 class="is-size-5 has-text-white">{{ item.title }}</h4>
          <p class="has-text-white">{{ item.ctx }}</p>
        </div>
      </div>
    </div>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: "Why",
  data() {
    return {
      title: "Why",
    };
  },
};
</script>
<style scoped>
.time-line {
  border-bottom: solid 3px white;
  height: 17px;
}
.time-line .time-line-icon {
  background-color: #ed404b;
  border-radius: 100px;
  margin: 0 1.3rem;
}
</style>
<i18n>
{
      "es":{
      "whyTitle":"¿Por qué Ceptinel ofrece una implementación rápida?",
      "why":"Porque aplicamos una metodología ágile entre equipos funcionales lo que nos permite implementar el proyecto en aproximadamente 4 meses enfocado en adaptarnos a los requerimientos del cliente y entregar un producto “Llave en mano”. Ceptinel tiene su proceso dividido en las siguientes cuatro etapas:",
      "timeLine":[
         {
            "time":"Mes 1",
            "title":"Solicitud de requerimientos",
            "ctx":"Mediante diferentes reuniones, se documentan los requerimientos específicos del cliente."
         },
         {
            "time":"Mes 2",
            "title":"Habilitación servidor y preparación datos",
            "ctx":"Ceptinel habilita el ambiente pre-productivo y prepara las interfaces para recibir las bases de datos."
         },
         {
            "time":"Mes 3",
            "title":"Desarrollo de reglas",
            "ctx":"Ceptinel crea las diferentes reglas en virtud a lo solicitado por cada cliente. Las calibra y reduce la cantidad de falsos positivos."
         },
         {
            "time":"Mes 4",
            "title":"Aprobación ambiente productivo y soporte",
            "ctx":"Habilitación ambiente productivo, creación de usuarios y capacitación al cliente. En adelante, Ceptinel dará un soporte constante post-producción."
         }
      ]
   },
   "en":{
      "whyTitle":"Why does Ceptinel offer quick implementation?",
      "why":"Because we apply an agile methodology between functional teams, which allows us to implement the project in approximately 4 months, focused on adapting to customer requirements and delivering a \"Turnkey\" product. Ceptinel has its process divided into the following four stages:",
      "timeLine":[
         {
            "time":"Month 1",
            "title":"Request for requirements",
            "ctx":"Through different meetings, the specific requirements of the client are documented."
         },
         {
            "time":"Month 2",
            "title":"Server enablement and data preparation",
            "ctx":"Ceptinel enables the pre-production environment and prepares the interfaces to receive the databases."
         },
         {
            "time":"Month 3",
            "title":"Rules development",
            "ctx":"Ceptinel creates the different rules according to what is requested by each client. It calibrates them and reduces the number of false positives."
         },
         {
            "time":"Month 4",
            "title":"Production environment approval and support",
            "ctx":"Enabling productive environment, user creation and customer training. From now on, Ceptinel will provide constant post-production support."
         }
      ]
   },
   "pt":{
   
   "whyTitle":"¿Por que o Ceptinel oferece implementação rápida?",
   "why":"Porque aplicamos uma metodologia ágil entre equipas funcionais, o que nos permite implementar o projeto em cerca de 4 meses, focado na adaptação aos requisitos do cliente e na entrega de um produto “chave na mão”. A Ceptinel tem seu processo dividido nas seguintes quatro etapas:",
   "timeLine":[
      {
         "time":"Mês 1",
         "title":"Solicitação de requisitos",
         "ctx":"Através de diferentes reuniões, os requisitos específicos do cliente são documentados."
      },
      {
         "time":"Mês 2",
         "title":"Habilitação do servidor e preparação de dados",
         "ctx":"Ceptinel habilita o ambiente de pré-produção e prepara as interfaces para receber os bancos de dados."
      },
      {
         "time":"Mês 3",
         "title":"Desenvolvimento de regras",
         "ctx":"A Ceptinel cria as diferentes regras de acordo com o que é solicitado por cada cliente. Calibra-os e reduz o número de falsos positivos."
      },
      {
         "time":"Mês 4",
         "title":"Aprovação e suporte do ambiente de produção",
         "ctx":"Habilitando ambiente produtivo, criação de usuários e treinamento de clientes. A partir de agora, a Ceptinel fornecerá suporte constante de pós-produção."
      }
   ]
}
}
</i18n>
